<div class="label_properties">
  <small class="debug">{{me}}</small>
  <a mat-raised-button color="primary" href="https://www.canva.com/" target="_blank" style="text-decoration: none;">Open Canva</a>
  <br/>
  <br/>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
    </div>
  }
  <br/>
  <div style="padding: 10px; border: 1px dodgerblue dashed">
    <mat-label>
      Usage: in Canva, go to Share > More > Embed > [Copy] the smart embed link and paste above
    </mat-label>
  </div>

</div>
